export enum FuncionalidadeEnum {
  PERGUNTAS = 'PERGUNTAS',
  CHECKLIST = 'CHECKLIST',
  INTERVENCAO = 'INTERVENCAO',
  ATIVIDADE = 'ATIVIDADE',
  TOMBAMENTO = 'TOMBAMENTO',
  LICITACAO = 'LICITACAO',
  PLATAFORMA_ELETRONICA = 'PLATAFORMA_ELETRONICA',
  REGULAMENTACOES_DOCUMENTOS = 'REGULAMENTACOES_DOCUMENTOS'
}
